export enum AppVersionLockerButtonActionEnum {
    link = 'link',
    close = 'close',
    internalRedirect = 'internalRedirect',
    void = 'void'
}
